module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "logisticscontainer",
    staticClass: "logistics-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10,
      "align": "left"
    }
  }, [(_vm.loginRole !== 2) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (_vm.loginRole !== 2) ? _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")]) : _vm._e(), _vm._v(" "), (_vm.loginRole !== 2) ? _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchDel
    }
  }, [_vm._v("批量删除")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "left"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "placeholder": "按区域搜索"
    },
    on: {
      "change": _vm.getData
    },
    model: {
      value: (_vm.sortAreaId),
      callback: function($$v) {
        _vm.sortAreaId = $$v
      },
      expression: "sortAreaId"
    }
  }, _vm._l((_vm.allAreaDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.areaname,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "right"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "快速搜索"
    },
    on: {
      "change": _vm.getData
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.getData.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.vague),
      callback: function($$v) {
        _vm.vague = $$v
      },
      expression: "vague"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "right"
    }
  }, [(_vm.loginRole !== 2) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadTemplate
    }
  }, [_vm._v("下载导入模板")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "center"
    }
  }, [(_vm.loginRole !== 2) ? _c('a', {
    staticClass: "file importFile",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("导入Excel\n\t\t\t\t\t\t"), _c('input', {
    attrs: {
      "id": "file",
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    on: {
      "change": function($event) {
        return _vm.importExcel($event)
      }
    }
  })]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('af-table-column', {
    attrs: {
      "type": "selection",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "logisticsid",
      "label": "快递单号",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "ordercode",
      "label": "订单编号",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "u8id",
      "label": "U8id",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "logisticsname",
      "label": "物流公司",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "u8orderid",
      "label": "U8系统发货单号",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "creattime",
      "label": "创建时间",
      "formatter": _vm.formatCreattime,
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "creatuser",
      "label": "创建人",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "updatetime",
      "label": "最后修改时间",
      "formatter": _vm.formatUpdatetime,
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "updateuser",
      "label": "修改人",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "220",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.loginRole !== 2) ? _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (_vm.loginRole !== 2) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.loginRole !== 2) ? _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.loginRole !== 2) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.clickWayBill(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看物流")])]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "快递单号",
      "prop": "logisticsid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.logisticsid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "logisticsid", $$v)
      },
      expression: "formData.logisticsid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单编号",
      "prop": "ordercode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.ordercode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordercode", $$v)
      },
      expression: "formData.ordercode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "U8id",
      "prop": "u8id"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.u8id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "u8id", $$v)
      },
      expression: "formData.u8id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物流公司",
      "prop": "logisticsname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.logisticsname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "logisticsname", $$v)
      },
      expression: "formData.logisticsname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "U8系统发货单号",
      "prop": "u8orderid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.u8orderid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "u8orderid", $$v)
      },
      expression: "formData.u8orderid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": '物流信息',
      "visible": _vm.logisticsDialogVisible,
      "width": "700px",
      "height": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.logisticsDialogVisible = $event
      }
    }
  }, [_c('section', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('label', {
    staticClass: "billNo"
  }, [_vm._v("运单号：" + _vm._s(_vm.logisticsBillNo))]), _vm._v(" "), _c('label', {
    staticClass: "billState"
  }, [_vm._v(_vm._s(_vm.logisticsStatu))]), _vm._v(" "), _c('section', {
    staticClass: "billContent"
  }, [_c('ul', {
    staticClass: "bcul"
  }, _vm._l((_vm.logisticsDatas), function(lo, index) {
    return _c('li', {
      key: lo.operatetime,
      staticClass: "bcli",
      style: (index == 0 ? 'color: #E3A53F;' : '')
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('span', {
      staticClass: "el-icon-location"
    })]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('span', [_vm._v(_vm._s((!!lo.date ? _vm.formatTitle(lo.date, lo.time) : lo.acceptTime)))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', {
      staticClass: "bccon",
      domProps: {
        "innerHTML": _vm._s(lo.content)
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(lo.content) + "\n\t\t\t\t\t\t\t\t\t")])])], 1)], 1)
  }), 0)]), _vm._v(" "), _c('section', [_c('label', {
    staticClass: "billState consignmentState"
  }, [_vm._v("发货单状态：" + _vm._s(_vm.consignment.define14))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83e60c68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/logisticsManagement/Logistics.vue
// module id = 715
// module chunks = 1